import { useState } from "react";
import { Image, InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/esm/Form";
import { Link } from "react-router-dom";
import MenuProductSelect from "../screens/MenuProductSelect";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function ProductQuestions(props) {
  const {
    question,
    productQuestionChangeHandler,
    productQuestionAnswerChangeHandler,
    productQuestionAnswerWithProductChangeHandler,
    productQuestionAnswerDeleteHandler,
    productQuestionDeleteHandler,
    productQuestionAnswerAddHandler,
    productQuestionCompulsoryOptionChangeHandler,
    productQuestionMultiOptionChangeHandler,
    questionIndex,
  } = props;

  const [showDetail, setShowDetail] = useState(!question._id);
  const [showSelectProduct, setShowSelectProduct] = useState(false);
  const [productAddHandler, setProductAddHandler] = useState();

  const productAddHandlerClousure = (ai, q, qi) => {
    function call(product, feature) {
      return productQuestionAnswerWithProductChangeHandler(
        ai,
        q,
        qi,
        product,
        feature
      );
    }
    return call;
  };

  return (
    <div
      className="mb-3 p-2 bg-light"
      style={{
        border: "1px solid #ddd",
        borderRadius: "5px",
        position: "relative",
      }}
    >
      {!showDetail ? (
        <div style={{ position: "absolute", top: "5px", right: "5px" }}>
          <Link to="#" onClick={() => setShowDetail(true)}>
            <i className="fas fa-edit" style={{ fontSize: "18px" }} />
          </Link>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
          }}
        >
          {question.answers.filter((a) => !a.answer).length === 0 && (
            <Link
              to="#"
              onClick={() => {
                setShowDetail(false);
              }}
            >
              <i className="fas fa-angle-up" style={{ fontSize: "18px" }} />
            </Link>
          )}
        </div>
      )}

      {!showDetail ? (
        <div className="p-1 ">
          {question.compulsory && (
            <>
              <span
                className="text-danger text-bold"
                style={{ fontSize: "18px" }}
              >
                *
              </span>
              &nbsp;
            </>
          )}
          <span
            className={
              question.compulsory ? "text-bold text-danger" : "text-bold"
            }
          >
            {question.question}
          </span>
          <ul
            style={{ listStyleType: question.multi ? "square" : "circle" }}
            className="answerSingle"
          >
            {question.answers
              .filter((a) => !a.deleted)
              .map((a, i) => (
                <li key={a._id || i}>
                  {a.answer}

                  {!!a.firstCost && a.firstCost > a.cost && (
                    <>
                      &nbsp;&nbsp;
                      <span className="text-bold text-muted textDecorationLine">
                        {turkishCurrencyFormatterNoPrecision(a.firstCost)}
                      </span>
                    </>
                  )}
                  <span className="text-bold">
                    &nbsp;&nbsp;{" "}
                    {!!a.cost && turkishCurrencyFormatterNoPrecision(a.cost)}
                  </span>
                </li>
              ))}
          </ul>
        </div>
      ) : (
        <div
          className="p-1 bg-light"
          style={{
            marginBottom: "0px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
            className="mb-2"
          >
            <div className="me-2" style={{ width: "100%" }}>
              <Form.Group>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Soru"
                  required
                  value={question.question}
                  onChange={(e) => {
                    productQuestionChangeHandler(e, questionIndex, question);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Lütfen cevap alanini boş bırakmayınız
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div>
              <Form.Group>
                <Form.Check
                  className="mb-2"
                  type="checkbox"
                  label="Çoklu"
                  value={question.multi}
                  checked={question.multi}
                  onChange={(e) => {
                    productQuestionMultiOptionChangeHandler(
                      e,
                      questionIndex,
                      question
                    );
                  }}
                />

                <Form.Check
                  type="checkbox"
                  label="Zorunlu"
                  value={question.compulsory}
                  checked={question.compulsory}
                  onChange={(e) => {
                    productQuestionCompulsoryOptionChangeHandler(
                      e,
                      questionIndex,
                      question
                    );
                  }}
                />
              </Form.Group>
            </div>
          </div>
          {question.answers
            .filter((f) => !f.deleted)
            .map((f, i) => (
              <div
                key={f._id || i}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div className="me-2 mb-2" style={{ width: "100%" }}>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        placeholder={
                          question.answers.filter((a) => a.product).length > 0
                            ? "Ürün Seç"
                            : "Cevap"
                        }
                        required
                        value={f.answer}
                        onChange={(e) => {
                          productQuestionAnswerChangeHandler(
                            e,
                            i,
                            question,
                            questionIndex,
                            "answer"
                          );
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => {
                          setShowSelectProduct(true);
                          setProductAddHandler(() =>
                            productAddHandlerClousure(
                              i,
                              question,
                              questionIndex
                            )
                          );
                        }}
                      >
                        {f.product ? (
                          <Image
                            fluid
                            rounded
                            src={f.image}
                            alt={"Yok"}
                            style={{ maxWidth: "30px" }}
                          ></Image>
                        ) : (
                          <i className="fas fa-gift"></i>
                        )}
                      </button>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">
                      Lütfen cevap alanini boş bırakmayınız
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="me-2 mb-2" style={{ width: "100px" }}>
                  <Form.Group>
                    <Form.Control
                      placeholder="₺"
                      type="number"
                      value={f.cost}
                      onChange={(e) => {
                        productQuestionAnswerChangeHandler(
                          e,
                          i,
                          question,
                          questionIndex,
                          "cost"
                        );
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="me-2 mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={(e) => {
                      productQuestionAnswerDeleteHandler(
                        f._id,
                        i,
                        question,
                        questionIndex
                      );
                    }}
                  >
                    <i className="fas fa-trash "></i>
                  </button>
                </div>
              </div>
            ))}
          <div>
            <div colSpan={3}>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => {
                    productQuestionAnswerAddHandler(questionIndex, question);
                  }}
                >
                  <i className="fas fa-plus"></i>&nbsp; {"Cevap Ekle"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => {
                    productQuestionDeleteHandler(question._id, questionIndex);
                  }}
                >
                  {"Soruyu Sil"}&nbsp;
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <MenuProductSelect
        showSelectProduct={showSelectProduct}
        setShowSelectProduct={setShowSelectProduct}
        productAddHandler={productAddHandler}
      />
    </div>
  );
}
